module.exports = __webpack_public_path__ + "img/icon_design_off.64c2ceda.svg";